import { renderForCriticalMoment } from "../dashHelper";
import { commonWidgets, DEFAULT_COLORS_NPS, getOxxoRetailGaugeInsightDataList, getOxxoRetailNbsByGeo, OXXO_COLORS_CONFIG_SCALE_5, OXXO_SCALE_3_COLORS } from "./commonWidgetsOxxoRetail";
import { getCommonWidget } from "../dashWidgetHelper";
import { DEFAULT_COLORS_WIDGETS } from "@components/widgets/apacheEchart/Commons";
import useClientConfig from "config/clients/useClientConfig";
import useAccount from "@hooks/useAccount";
import { forEach } from "lodash";
import Item from "antd/lib/list/Item";

const getNode = (geoLocations: GeoDistribution[], id: number): any => {
    if (!geoLocations || geoLocations.length == 0) {
        return;
    }

    var node = undefined;
    for(var i = 0; i < geoLocations.length; ++i) {
        const geoLocation = geoLocations[i];
        if(geoLocation.id == id) {
            node = geoLocation;
            break;
        }

        node = getNode(geoLocation.children, id);
        if(node) {
            break;
        }
    };
    return node;
};

const getAllByLevel = (geoLocations: GeoDistribution[], level: string): GeoDistribution[] => {
    let results:GeoDistribution[] = [];
    if (!geoLocations || geoLocations.length == 0) {
        return results;
    }

    for (var i = 0; i < geoLocations.length; ++i) {
        const geoLocation = geoLocations[i];
        if(geoLocation.level == level) {
            results.push(geoLocation);
        } else {
            results.push(...getAllByLevel(geoLocation.children, level));
        }
    }

    return results;
};


export default {
    title: 'Dashboard Metas',
    description: 'Dashboard de perfil Metas',
    backgroundClassName: (filters) => 'default',
    widgets: (filters: FiltersUI) => {
        const { getCriticalMomentsRootId, getGeosRootId } = useClientConfig();
        const { geoLocations } = useAccount();
        //filters.geographicDistributions
        //Ejemplo isRegionGeoLocation verifica eoi el id esta en una lista predefinida
        //29, 6444 (Centro Sur),13703 (Golfo Bajito),30 (Norte), 21497 (Pacifico)
        const nodeRoot = getNode(geoLocations, 29);
        const nodeZonaCentroSur = getNode(geoLocations, 6444);
        const nodeZonaGolfoBajito = getNode(geoLocations, 13703);
        const nodeZonaNorte = getNode(geoLocations, 30);
        const nodeZonaPacifico = getNode(geoLocations, 21497);

        const nodesAsesor = getAllByLevel(geoLocations, "ASESOR");
        const nodesAsesorId = nodesAsesor.map(node => node.id).filter(id => filters.geographicDistributions.includes(id));
        const showAsesor = nodesAsesorId.length > 0; 

        const showRoot = (nodeRoot!= null && filters.geographicDistributions.includes(nodeRoot.id))

        const showZonaPacifico = (showRoot || (nodeZonaPacifico != null && filters.geographicDistributions.includes(nodeZonaPacifico.id)));
        const showZonaCentroSur = (showRoot || (nodeZonaCentroSur != null && filters.geographicDistributions.includes(nodeZonaCentroSur.id)));
        const showZonaGolfoBajito = (showRoot || (nodeZonaGolfoBajito != null && filters.geographicDistributions.includes(nodeZonaGolfoBajito.id)));
        const showZonaNorte = (showRoot || (nodeZonaNorte != null && filters.geographicDistributions.includes(nodeZonaNorte.id)));

        const widgetsArray = [
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'multipleTrendByMonth',
            title: 'NPS',
            size: [1, 2],
            key: 'nps-multiple-trend-by-month',
            indicator: 'oxxo_retail_npm_recomienda',
            
            //criticalMomentInclude: [29],//this critical momenet id overwrits the others
            mapper: (data, extra) => {
                //console.log("NPS - METAS")
                //console.log(data)
                //console.log(extra)

                return data.map((item: any, idx: any) => ({
                    ...item,
                    groupName: item.groupName + ' (' + item.value + ')',
                }))
            },
            extraConfigs: {
                colors: DEFAULT_COLORS_NPS,
                useCurrent: 0,
                categories: ['promoters', 'passives', 'detractors'],
                categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
            }
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'semicircleGeneric',
            title: 'Composición NPS',
            key: 'nps-por-mes',
            size: [1, 2],
            indicator: 'oxxo_retail_npm_recomienda',
            extraConfigs: {
                colors: OXXO_SCALE_3_COLORS,
                categories: ['promoters', 'passives', 'detractors'],
                useEmojis: false
            },

        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: 'Satisfacción',
            size: [2, 2],
            indicator: 'oxxo_retail_gral_npm_satisf_tienda',
            helpText: '<p><b>Pregunta: </b><br/><br/>Pensando en tu visita de hoy, ¿Qué tan satisfecho(a) estás con tu experiencia en esta tienda?.</p>',

            extraConfigs: {
                decimals: 1,
                maxValue: 5,
                showPercentage: false,
                colors: OXXO_COLORS_CONFIG_SCALE_5,
            },
            historic: {
                type: 'line',
                formula: 'wavg-5',
            }
        }),

        {
            title: 'Tendencia mensual y Correlación',
            type: 'label',
            size: [4, 1],
        },

        {
            title: 'NPS General tendencia mensual',
            size: [2, 2],
            config: {
                id: 'line-nps-general-meta-by-month',
                type: 'line',
                colors: DEFAULT_COLORS_WIDGETS,
                showValues: false,
                smooth: false,
                decimals: 1,
                extraConfigs: {
                    decimals: 1,
                    showPercentage: false,
                },
                
                targetConfig: {
                    targetQuestion: 'nps',
                    targetMetricType: 'NPS'
                },

                mapper: (data: any, extra: any) => {

                    //console.log("***************surveyLineTrendByMonth mapper by time band")
                    //console.log(data)
                    
                    const series = [
                      ...data.map((item: any, idx: number) => ({
                          ...item,
                          id: idx,
                          category: item.groupName ? item.groupName : item['group_0'],
                          groupName: item['group_0'] ? item['group_0'] : item.groupName,
                          group_1: (item['group_1'] ? item['group_1'] : item.label),
                      })),

                      ...data.map((item: any, idx: number) => ({
                          ...item,
                          id: idx + data.length,
                          category: item.groupName ? item.groupName : item['group_0'],
                          groupName: 'Meta', //item['group_0'] ? item['group_0'] : item.groupName,
                          group_1: (item['group_1'] ? item['group_1'] : item.label),
                          value: item?.metricTargets?.[extra.config.targetConfig?.targetQuestion]?.[extra.config.targetConfig?.targetMetricType]?.value
                      })),
                    ];

                    return series.sort((a, b) => a.group_1.localeCompare(b.group_1, undefined, { sensitivity: 'base' }));

                },
                indicators: [
                    {
                        key: 'oxxo_retail_npm_recomienda',
                        indicator: 'oxxo_retail_npm_recomienda',
                        grouped: 'geoLocation,formattedMonth',
                        //criticalMomentId: 29,
                        keyExtract: ['group_0', 'group_1', 'value', 'groupName','metricTargets'],
                        label: 'group_0',
                        value: 'value',
                        sort: { sortBy: 'group_0', value: 'asc' },
                        singleton: true,
                        extras: {
                          periods: 6,
                          decimals: 1,
                          
                          groupByLevel: 1,
                        },
                    },
                    
                ],
                         
            },

        },

         {
            title: 'Correlación NPS vs Satisfacción por mes',
            // [Column, Row]
            size: [2, 2],
            config: {
                id: 'survey-line-trend-by-month',
                type: 'line',
                colors: DEFAULT_COLORS_WIDGETS,
                radius: [40, 85],
                center: ['40%', '55%'],
                showHistoric: false,
                showSample: false,
                legendOrient: 'vertical',
                showYLine: true,
                smooth: false,
                multiAxis: true,
                //legendItemWidth: 10,
                groups: [
                    'NPS',
                    'Satisfacción',
                ],
                decimals: 1,
                extraConfigs: {
                    decimals: 1,
                    //maxValue: 5,
                    showPercentage: false,
                },
                min: 1,
                max: 100,
                //wrapXAxisText: true,
                mapper: (data: any) => {
                    // API formattedMonth uses `group` as "YYYY-MM" (e.g. "2025-12"), not group_0
                    const resultSurvey = (data['oxxo_retail_gral_npm_satisf_tienda'] || []).map((item: any) => ({
                        label: item.groupName,
                        groupName: item.groupName,
                        group: "Satisfacción",
                        category: item.groupName,
                        value: item.value,
                        yAxisIndex: 0,
                        symbol: '',
                        decimals: 1,
                        min: 1,
                        max: 5,
                        sortKey: item.group ?? item.group_0,
                    }))

                    const resultAlert = (data['oxxo_retail_npm_recomienda'] || []).map((item: any) => ({
                        label: item.groupName,
                        groupName: item.groupName,
                        group: "NPS",
                        category: item.groupName,
                        value: item.value,
                        yAxisIndex: 1,
                        symbol: '%',
                        decimals: 1,
                        min: 1,
                        max: 100,
                        sortKey: item.group ?? item.group_0,
                    }))

                    return [...resultSurvey, ...resultAlert].sort((a, b) =>
                        String(a.sortKey ?? '').localeCompare(String(b.sortKey ?? ''), undefined, { sensitivity: 'base' })
                    )
                },
                indicators: [
                    {
                        key: 'oxxo_retail_npm_recomienda',
                        indicator: 'oxxo_retail_npm_recomienda',
                        grouped: 'formattedMonth',
                        keyExtract: [
                            'value',
                            'groupName',
                            'group',
                            'group_0',
                        ],
                        label: 'groupName',
                        value: 'value',
                        singleton: true,
                        sort: { sortBy: 'group', value: 'asc' },
                        extras: {
                            //featureExclude: ['groupByTopLocation'],
                            periods: 10,
                            decimals: 1,
                        },
                    },
                    {
                        key: 'oxxo_retail_gral_npm_satisf_tienda',
                        indicator: 'oxxo_retail_gral_npm_satisf_tienda',
                        grouped: 'formattedMonth',
                        keyExtract: [
                            'group',
                            'value',
                            'groupName',
                            'label',
                            'group_0'
                        ],
                        label: 'groupName',
                        value: 'value',
                        singleton: true,
                        sort: { sortBy: 'group', value: 'asc' },
                        extras: {
                            //alertStatus: 'IN_PROCESS,CLOSED',
                            periods: 10,
                            decimals: 1,
                            min: 1,
                            max: 5,
                        },
                    },
                ],
            },
        },

        {
            title: 'Ranking de regiones',
            type: 'label',
            size: [4, 1],
        },
              
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByGeo',
            key: 'nps-by-geo-level-2',
            title: 'NPS por zona vs Meta',
            position: [0, 27],
            size: [2, 2],
            indicator: 'oxxo_retail_npm_recomienda',
                        
            targetConfig: {
                targetQuestion: 'nps',
                targetMetricType: 'NPS'
            },
            extras: {
              groupByLevel: 2, 
              //geoLocationInclude: [13703], //Agregar esto en nivles 3 
            },
            extraConfigs: {
                customTargetStyle: true,

                showTargetLabel: false,
                showTargetMarkers: true,
                targetLineStyle: 'dotted',
                targetLineColor: '#1F163D',
                targetMarkerColor: '#1F163D',

                showBarValues: false,

                // clave para pocas barras:
                adaptiveBars: true,
                barWidth: '70%',
                barMaxWidth: 110,
            },
            mapper: (data: any) => {
                //console.log("POC - METAS")
                //console.log(data)
                return data
            }
        }),
        
        getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                //name: 'stackedBar',
                title: 'NPS · Clientes Spin Premia',
                size: [2, 2],
                indicator: 'oxxo_retail_npm_recomienda',
                extraConfigs: {
                    colors: OXXO_SCALE_3_COLORS,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    decimals: 0,
                },
                extras: {
                    formula: 'nps-10',
                    groupByResponseValueId: 13706,//Id de la pregunta
                    groupBy: "responseValue",
                    categories: ['promoters', 'passives', 'detractors'],
                },
                mapper: (data: any) => {
                    //console.log('Mapper misión principal de la visita - Barra')
                    //console.log(data)
                    var values = data;
                    return values
                },
        }),

        (showZonaCentroSur || showZonaGolfoBajito || showZonaNorte || showZonaPacifico) ?
        {
            title: 'Ranking de las 21 Regiones · agrupadas por zona',
            type: 'label',
            size: [4, 1],
        }: undefined,
        
        showZonaPacifico == true ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-3-Zona-Pacifico',
            title: 'Zona Pacifico',
            size: [2, 2],
            indicator: 'oxxo_retail_npm_recomienda',                        
            npsTargetConfig: true,
            groupByLevel: 3, 
            geoLocationInclude: [nodeZonaPacifico.id],
            extraConfigs: {
            customTargetStyle: true,

            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',

            showBarValues: false,

            // clave para pocas barras:
            adaptiveBars: true,
            barWidth: '70%',
            barMaxWidth: 110,
            } 
        }): undefined,

        showZonaNorte ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-3-Zona-Norte',
            title: 'Zona Norte',
            size: [2, 2],
            indicator: 'oxxo_retail_npm_recomienda',                        
            npsTargetConfig: true,
            groupByLevel: 3, 
            geoLocationInclude: [nodeZonaNorte.id], 
            extraConfigs: {
            customTargetStyle: true,

            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',

            showBarValues: false,

            // clave para pocas barras:
            adaptiveBars: true,
            barWidth: '70%',
            barMaxWidth: 110,
            }
        }): undefined,
        
        showZonaCentroSur ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-3-Zona-Centro-Sur',
            title: 'Zona Centro - Sur',
            size: [2, 2],
            indicator: 'oxxo_retail_npm_recomienda',                        
            npsTargetConfig: true,
            groupByLevel: 3, 
            geoLocationInclude: [nodeZonaCentroSur.id], 
            extraConfigs: {
            customTargetStyle: true,

            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',

            showBarValues: false,

            // clave para pocas barras:
            adaptiveBars: true,
            barWidth: '70%',
            barMaxWidth: 110,
            }
        }): undefined,

        showZonaGolfoBajito ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-3-Zona-Golfo-Bajio',
            title: 'Zona Golfo - Bajio',
            size: [2, 2],
            indicator: 'oxxo_retail_npm_recomienda',
            npsTargetConfig: true,
            groupByLevel: 3, 
            geoLocationInclude: [nodeZonaGolfoBajito.id],
            extraConfigs: {
            customTargetStyle: true,

            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',

            showBarValues: false,

            // clave para pocas barras:
            adaptiveBars: true,
            barWidth: '70%',
            barMaxWidth: 110,
            }
        }): undefined,

        (showZonaCentroSur || showZonaGolfoBajito || showZonaNorte || showZonaPacifico) ?
        {
            title: 'Ranking de las 107 Plazas · agrupadas por zona',
            type: 'label',
            size: [4, 1],
        }: undefined,

        showZonaPacifico ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-4-Zona-Pacifico',
            title: 'Zona Pacifico',
            size: [2, 3],
            indicator: 'oxxo_retail_npm_recomienda',                        
            npsTargetConfig: true,
            groupByLevel: 4, 
            geoLocationInclude: [nodeZonaPacifico.id], 
            extraConfigs: {
            adaptiveBars: true,
            customTargetStyle: true,
            showBarValues: false,
            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',
            rotateXAxisLegend: true,
            barMaxWidth: 24,
            },
        }): undefined,

        showZonaNorte ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-4-Zona-Norte',
            title: 'Zona Norte',
            size: [2, 3],
            indicator: 'oxxo_retail_npm_recomienda',                        
            npsTargetConfig: true,
            groupByLevel: 4, 
            geoLocationInclude: [nodeZonaNorte.id], 
            extraConfigs: {
            adaptiveBars: true,
            customTargetStyle: true,
            showBarValues: false,
            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',
            rotateXAxisLegend: true,
            barMaxWidth: 24,
            },
        }): undefined,

        showZonaCentroSur ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-4-Zona-Centro-Sur',
            title: 'Zona Centro - Sur',
            size: [2, 3],
            indicator: 'oxxo_retail_npm_recomienda',                        
            npsTargetConfig: true,
            groupByLevel: 4, 
            geoLocationInclude: [nodeZonaCentroSur.id], 
            extraConfigs: {
            adaptiveBars: true,
            customTargetStyle: true,
            showBarValues: false,
            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',
            rotateXAxisLegend: true,
            barMaxWidth: 24,
            },
        }): undefined,

        showZonaGolfoBajito ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-4-Zona-Golfo-Bajio',
            title: 'Zona Golfo - Bajio',
            size: [2, 3],
            indicator: 'oxxo_retail_npm_recomienda',
            npsTargetConfig: true,
            groupByLevel: 4, 
            geoLocationInclude: [nodeZonaGolfoBajito.id],
            extraConfigs: {
            adaptiveBars: true,
            customTargetStyle: true,
            showBarValues: false,
            showTargetLabel: false,
            showTargetMarkers: true,
            targetLineStyle: 'dotted',
            targetLineColor: '#1F163D',
            targetMarkerColor: '#1F163D',
            rotateXAxisLegend: true,
            barMaxWidth: 24,
            },
        }): undefined,

        showAsesor ?
        getOxxoRetailNbsByGeo({
            key: 'nps-by-geo-level-6-Asesores',
            title: 'Tiendas Asesor',
            size: [4, 3],
            indicator: 'oxxo_retail_npm_recomienda',
            npsTargetConfig: false,
            groupByLevel: 6, 
            geoLocationInclude: nodesAsesorId,
            extraConfigs: {
                adaptiveBars: true,
                customTargetStyle: true,
                showBarValues: false,
                showTargetLabel: false,
                showTargetMarkers: true,
                targetLineStyle: 'dotted',
                targetLineColor: '#1F163D',
                targetMarkerColor: '#1F163D',
                rotateXAxisLegend: true,
                barMaxWidth: 24,
            },
        }): undefined,



        {
            title: 'Encuestas respondidas · navegación por nivel',
            helpLink: '--',
            position: [0, 11,],
            size: [4, 2,],
            config: {
              id: 'number-surveys-month',
              type: 'bar',
              showHistoric: false,
              percentageScale: false,
              mapper: (data: any, extra: any): any => {
                
                return data.map((item: any, idx: any) => ({
                  id: idx,
                  category: item.groupName ? item.groupName : item['group_0'],
                  groupName: item['group_0'] ? item['group_0'] : item.groupName,
                  group: item['group_0'] ? item['group_0'] : item.groupName,
                  value: item.value?.answeredCount || 0,
                })).sort((item1: any, item2: any) => item2.value - item1.value)
              },
              extraConfigs: {
                seriesName: '',
                tooltipValueLabel: 'Encuestas respondidas'
              },
              indicators: [
                {
                  indicator: 'SURVEY_COUNT',
                  grouped: 'geoLocation',
                  keyExtract: ['group_0', 'group_1', 'group', 'value', 'groupName',],
                  label: 'group',
                  value: 'value',
                  dataType: 'list',
                  singleton: true,
                  historic: false,
                  sort: { 'sortBy': 'value.answeredCount', value: 'desc', },
                  extras: {
                    //groupByLevel: 2, 
                    geoLocationInclude: [29],//13703,21497,30,6444],
                  }
                },
              ],
            },
          },

        {
            title: 'Análisis por turnos',
            type: 'label',
            size: [4, 1],
        },

        getOxxoRetailGaugeInsightDataList({
          size: [1, 3],
          turno: "Matutino",
        }),
        getOxxoRetailGaugeInsightDataList({
          size: [1, 3],
          turno: "Vespertino",
        }),
        getOxxoRetailGaugeInsightDataList({
          size: [1, 3],
          turno: "Nocturno",
        }),


        {
            title: 'Análisis por turnos - Comparativo mensual',
            type: 'label',
            size: [4, 1],
        },

        {
            title: 'Correlación NPS',
            size: [4, 2],
            config: {
                id: 'line-detailed-by-month-and-geo-period',
                type: 'line',
                colors: DEFAULT_COLORS_NPS,
                showValues: false,
                smooth: false,
                decimals: 1,
                extraConfigs: {
                    decimals: 1,
                    showPercentage: false,
                },
                
                targetConfig: {
                    targetQuestion: 'nps',
                    targetMetricType: 'NPS'
                },

                mapper: (data: any, extra: any) => {

                    //console.log("***************surveyLineTrendByMonth mapper by time band")
                    //console.log(data)

                    const metaValue = 76.4; //(data || []).find((item: any) => item.metricTargets != null)?.metricTargets?.[extra.config.targetConfig?.targetQuestion]?.[extra.config.targetConfig?.targetMetricType]?.value;
                    const series = [
                      ...data.map((item: any, idx: number) => ({
                          ...item,
                          id: idx,
                          category: item.groupName ? item.groupName : item['group_0'],
                          groupName: item['group_0'] ? item['group_0'] : item.groupName,
                          group_1: (item['group_1'] ? item['group_1'] : item.label),
                      })),
                    ];

                    const metasNocturno = series.filter(s => s.group_0 == 'Nocturno').map((s, idx) => ({
                      id: series.length + idx,
                      category: s.category,
                      groupName: 'Meta Nocturno',//Nocturno
                      group_1: s.group_1,
                      value: metaValue,
                    }))

                    return [...series, ...metasNocturno].sort((a, b) => a.group_1.localeCompare(b.group_1, undefined, { sensitivity: 'base' }));

                },
                indicators: [
                    {
                        key: 'oxxo_retail_npm_recomienda2',
                        indicator: 'oxxo_retail_npm_recomienda',
                        grouped: 'formattedTimeBand,formattedMonth,geoLocation',
                        //criticalMomentId: 29,
                        keyExtract: ['group_0', 'group_1','group_2' , 'value', 'groupName','metricTargets'],
                        label: 'group_0',
                        value: 'value',
                        sort: { sortBy: 'group_0', value: 'asc' },
                        singleton: true,
                        extras: {
                          periods: 6,
                          decimals: 1,
                          
                          groupByLevel: 1,
                        },
                    },
                    
                ],
                         
            },




        },



          /*
          getCommonWidget({
                      commonWidgets: commonWidgets,
                      name: 'surveyCountTrendByMonth',
                      position: [0, 4],
                      size: [1, 2],
                      indicator: 'SURVEY_COUNT',

                          subTitle: "Sub titutlo",
                      //criticalMomentInclude: [getCmID("venta")]
                      mapper: (data: any, extra) => {
                        return [{
                          id:1, 
                          value: data[0]?.value?.answeredCount,
                          name: "Nombre",
                          category: "Categoria",
                          subTitle: "Sub titutlo"
                        }];
                      },
                      extras: {
                        //geoLocations: 13703,
                        geoLocationInclude: [13703,21497,30,6444],
                        grouped: 'formattedMonth,geoLocation',
                        keyExtract: ['group_0', 'group_1', 'group', 'value', 'groupName',],
                      }
                  }),

                  {
                    title: 'FALTA',
                    // [Column, Row]
                    position: [0, 2],
                    size: [1, 2],
                    config: {
                        id: 'generic-trend-by-geo',
                        type: 'trend',
                        color: '#f38625',
                        valueSymbol: '%',
                        showHistoric: false,
                        showSample: true,
                        showTrend: false,
                        decimals: 2,
                        multiIndicator: true,
                        indicators: [
                            {
                                indicator: 'SURVEY_COUNT',
                                grouped: 'geoLocation',
                                keyExtract: ['value', 'groupName', 'count', 'group'],
                                value: 'value',
                                singleton: true,
                                //limit: 5,
                                //sort: { sortBy: 'value', value: 'asc' },
                                extras: {
                                    featureInclude: ['zoomOut'],
                                    //featureInclude: ['zoomOut', 'groupBySelfInclude'],
                                    //maxGroupByLevel: 2
                                }
                            }
                        ],
                        mapper: (data: any, extra) => {
                                    return data;
                                  },

                    },
                  },
  
        {
          title: 'TODO',
          // [Column, Row]
          position: [1, 1],
          size: [1, 2],
          config: {
            id: 'generic-single-trend',
            type: 'singleTrend',
            color: '#f38625',
            valueSymbol: '%',
            showHistoric: false,
            showSample: true,
            decimals: 2,
            mapper: (data: any, extra) => {
              return data[0]?.value?.answeredCount;
            },
            indicators: [
              {
                indicator: 'SURVEY_COUNT',
                grouped: 'geoLocation',
                keyExtract: ['value', 'groupName', 'count'],
                value: 'value',
                singleton: true,
                sort: { sortBy: 'group', value: 'asc' },
                extras: {
                  //periods: 6,
                  //model: 'avg'
                  groupByLevel: 2, 
                  geoLocations: 13703,
                  geoLocationInclude: [13703],
                  //grouped: 'formattedMonth,geoLocation',
                  //keyExtract: ['group_0', 'group_1', 'group', 'value', 'groupName',],
                }
              },
            ],
          },
        },
*/

    ].filter(w => w != undefined);
    return widgetsArray;
},

} as DasboardConfig;
